import { theme } from 'lib/theme';
import React from 'react';
import { GestureResponderEvent, View } from 'react-native';
import {
  getMenuAnchorPosition,
  Menu,
  MenuAnchorPosition,
  MenuProps,
} from './Menu';
import { Pressable, PressableProps } from './Pressable';

export const PressableWithMenu: React.FC<
  PressableProps & {
    menuOptions?: MenuProps['options'] | undefined;
    menuOnPress?: boolean;
    showMenuOnContext?: boolean;
  }
> = (props) => {
  const [menuPosition, setMenuPosition] = React.useState<MenuAnchorPosition>({
    type: 'point',
    x: 0,
    y: 0,
  });

  const [menuVisible, setMenuVisible] = React.useState(false);

  const { menuOptions, menuOnPress, onPress, showMenuOnContext = true } = props;

  const handlePress = React.useCallback((event: GestureResponderEvent) => {
    const position = getMenuAnchorPosition(event);
    if (!position) {
      return;
    }
    setMenuPosition(position);
    setMenuVisible(true);
  }, []);

  const handleContextPress = React.useCallback((event: MouseEvent) => {
    event.preventDefault();
    event.stopPropagation();
    setMenuPosition({
      type: 'point',
      x: event.pageX,
      y: event.pageY,
    });
    setMenuVisible(true);
  }, []);

  const handleDismissMenu = React.useCallback(() => setMenuVisible(false), []);

  if (!menuOptions?.length) {
    return <Pressable {...props} />;
  }

  return (
    <Pressable
      {...props}
      onContextPress={showMenuOnContext ? handleContextPress : undefined}
      onPress={onPress || (menuOnPress ? handlePress : undefined)}
      menuElement={
        <View
          style={{
            position: 'absolute',
            zIndex: 999,
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: menuVisible ? theme.colors.blue10 : undefined,
            pointerEvents: 'none',
          }}
        >
          <Menu
            visible={menuVisible}
            options={menuOptions}
            onDismiss={handleDismissMenu}
            {...(menuPosition.type === 'point'
              ? { x: menuPosition.x, y: menuPosition.y }
              : {
                  parentBounds: {
                    left: menuPosition.left,
                    right: menuPosition.right,
                    top: menuPosition.top,
                    bottom: menuPosition.bottom,
                  },
                })}
          />
        </View>
      }
    />
  );
};
